const XAXIS_INTERVAL_QUANTITY = 4;

export const getxAxisInterval = (
  series: echarts.SeriesOption[]
): Date[] | undefined => {
  if (series && series[0] && Array.isArray(series[0].data)) {
    const seriesData = series[0].data as Array<[string, number]>;
    const dataLength = seriesData.length ?? 0;

    if (dataLength > XAXIS_INTERVAL_QUANTITY) {
      const intervalsNumber = Math.round(dataLength / XAXIS_INTERVAL_QUANTITY);

      const xAxisValues = new Array(XAXIS_INTERVAL_QUANTITY)
        .fill(0)
        .map((value, index) =>
          index * intervalsNumber < dataLength &&
          seriesData[index * intervalsNumber]
            ? new Date(seriesData[index * intervalsNumber][0])
            : new Date(seriesData[dataLength - 1][0])
        );

      xAxisValues.push(new Date(seriesData[dataLength - 1][0]));

      return xAxisValues;
    }

    return seriesData.map((data) =>
      data?.length > 0 ? new Date(data[0]) : new Date()
    );
  }

  return undefined;
};
